// extracted by mini-css-extract-plugin
module.exports = {"inline_upload_animation":"uploadAnimation_inline_upload_animation__1W9iz"};